export default __webpack_public_path__ + "static/media/Dextran.b8596718.jpg";